// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3tNcZ","signatureButtonsRight":"ModalSign_signatureButtonsRight__1zEeD"};